import { render } from "./CreateFrivilligJob.vue?vue&type=template&id=61189ba0"
import script from "./CreateFrivilligJob.vue?vue&type=script&lang=js"
export * from "./CreateFrivilligJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__